<template>
    <div class="sui-switch"
        :class="{'sui--on': value}" :style="styleOutter"
        @click="toggle($event)">
        <div class="sui--circle"
            :style="styleInner"></div>
    </div>
</template>

<script>
import Mixin from '../../scripts/mixin'

export default {
    name: 'sui-switch',

    mixins: [Mixin],

    model: {
        prop: 'value',
        event: 'change'
    },

    props: {
        value: Boolean,

        // 自定义主题色
        colors: {
            type: Object,
        }
    },

    computed: {
        styleOutter() {
            return this.value ? {
                'border-color': this.mColor(4),
                'background': this.mColor(4)
            } : {
                'border-color': this.mColor(8),
            }
        },

        styleInner() {
            return this.value ? {
                'border-width': 0,
                'box-shadow': 'none'
            } : {
                'border-color': this.mColor(8.1),
            }
        }
    },

    methods: {
        toggle(event) {
            event.stopPropagation()
            this.$emit('change', !this.value)
        }
    }
}
</script>

<style lang="postcss">
.sui-switch {
    flex: none;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    border-style: solid;
    transition-property: border-color, background;
    transition-duration: 0.16s;
    transition-timing-function: cubic-bezier(0.33, 0, 0.66, 1);
    @media (orientation: portrait) {
        width: 10.133vw;
        height: 6.133vw;
        border-width: 0.133vw;
        border-radius: 3.067vw;
    }
    @media (orientation: landscape) {
        width: 5.697vw;
        height: 3.448vw;
        border-width: 0.075vw;
        border-radius: 1.724vw;
    }
    .sui--circle {
        box-sizing: border-box;
        border-style: solid;
        border-radius: 50%;
        background: #fff;
        transition-property: border-width, border-color, box-shadow, transform;
        transition-duration: 0.256s;
        transition-timing-function: cubic-bezier(0.33, 0, 0.1, 1);
        @media (orientation: portrait) {
            width: 5.6vw;
            height: 5.6vw;
            border-width: 0.133vw;
            box-shadow: 0 0 1.333vw rgba(0, 0, 0, 0.2);
        }
        @media (orientation: landscape) {
            width: 3.148vw;
            height: 3.148vw;
            border-width: 0.075vw;
            box-shadow: 0 0 0.75vw rgba(0, 0, 0, 0.2);
        }
    }
}
.sui-switch.sui--on {
    .sui--circle {
        @media (orientation: portrait) {
            transform: translate3d(4vw, 0, 0);
        }
        @media (orientation: landscape) {
            transform: translate3d(2.249vw, 0, 0);
        }
    }
}
</style>